exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\r\n\r\naside.pcoded-slider.ng-sidebar {\r\n    top: 56px;\r\n}\r\n\r\n.slimscroll-wrapper, .scroll-window {\r\n    width: 100% !important;\r\n}\r\n\r\n.userlist-box.show {\r\n    display: -webkit-box;\r\n}\r\n\r\n.userlist-box.hide {\r\n    display: none;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Projects/Hb.Bet/ServerAPI/AdminAngular/src/app/layouts/admin/admin-layout.component.css
// module id = ../../../../../src/app/layouts/admin/admin-layout.component.css
// module chunks = main